// src/pages/Refrigerated.js
import React, { useState, useEffect, useRef } from 'react';
import './Refrigerated.css';

const Refrigerated = () => {
  const [formData, setFormData] = useState({ name: '', phone: '' });
  const [responseMsg, setResponseMsg] = useState('');

  // Для анимированных цифр
  const numbersRef = useRef(null);
  const [hasAnimated, setHasAnimated] = useState(false);
  const [counts, setCounts] = useState([0, 0, 0, 0]); // начальные значения

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('/api/requests', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, tab: 'refrigerated' }),
      });
      const data = await response.json();
      if (response.ok) {
        setResponseMsg(data.message || 'Заявка успешно отправлена!');
        setFormData({ name: '', phone: '' });
      } else {
        setResponseMsg(data.message || 'Ошибка при отправке');
      }
    } catch (err) {
      console.error(err);
      setResponseMsg('Ошибка подключения к серверу');
    }
  };

  // Анимация счётчиков при появлении секции на экране
  useEffect(() => {
    // Сохраняем текущее значение ref в переменную
    const currentRef = numbersRef.current;
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry.isIntersecting && !hasAnimated) {
        setHasAnimated(true);
      }
    }, { threshold: 0.3 });
  
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [hasAnimated]);
  

  // Когда hasAnimated становится true, запускаем плавное увеличение
  useEffect(() => {
    if (hasAnimated) {
      const finalValues = [450, 1500, 750, 15]; // конечные значения
      const increments = finalValues.map(value => Math.ceil(value / 50)); 
      // чем больше делитель, тем медленнее/плавнее анимация

      let frame = 0;
      const animate = () => {
        frame++;
        setCounts(prev => 
          prev.map((num, i) => {
            const next = num + increments[i];
            return next >= finalValues[i] ? finalValues[i] : next;
          })
        );
        if (frame < 50) {
          requestAnimationFrame(animate);
        }
      };
      requestAnimationFrame(animate);
    }
  }, [hasAnimated]);

  return (
    <div className="refrigerated-page">
      {/* Шапка */}
      <header className="refrigerated-header">
        <div className="header-overlay">
          <h1>Грузы до 1,5 тонн</h1>
          <p></p>
        </div>
      </header>
      {/* Форма заявки */}
      <section className="refrigerated-request">
        <div className="container">
          <h2>Оставьте заявку на перевозку</h2>
          <p>Наш менеджер свяжется с вами для уточнения всех деталей</p>
          <form className="request-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Ваше имя"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Ваш телефон"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <button type="submit">Отправить заявку</button>
          </form>
          {responseMsg && <p className="response-message">{responseMsg}</p>}
          <p className="disclaimer">
            Нажимая на кнопку, вы соглашаетесь на обработку персональных данных
          </p>
        </div>
      </section>
      {/* Информация */}
      <section className="refrigerated-info">
        <div className="container">
          <h2>Какой груз берем ?</h2>
          <p>
          Максимальный вес груза
          1,5 тонн 
          Габариты 3-6 * 2м
          Полезный объем 18 м3
          Вместительность 4-10 европалет
          </p>
          <h3>Кузов:</h3>
          <ul>
            <li>Фургон</li>
            <li>Тент</li>
            <li>Рефрижератор</li>
          </ul>
        </div>
      </section>

      {/* Наши преимущества */}
      <section className="refrigerated-advantages">
        <div className="container">
          <h2>Наши преимущества</h2>
          <div className="advantages-grid">
            <div className="advantage-item">
              <h3>Современное оборудование</h3>
              <p>Все наши рефрижераторы оснащены новейшими системами контроля температуры.</p>
            </div>
            <div className="advantage-item">
              <h3>Круглосуточный мониторинг</h3>
              <p>Отслеживаем состояние груза и температуру на всём пути следования.</p>
            </div>
            <div className="advantage-item">
              <h3>Гибкие тарифы</h3>
              <p>Предлагаем различные варианты перевозок и персональные предложения для постоянных клиентов.</p>
            </div>
          </div>
        </div>
      </section>


      {/* Схема работы */}
      <section className="refrigerated-scheme">
        <div className="container">
          <h2>Схема работы</h2>
          <div className="scheme-steps">
            <div className="scheme-step">
              <div className="scheme-icon step-icon-1"></div>
              <p>Принимаем заявку на перевозку</p>
            </div>
            <div className="scheme-step">
              <div className="scheme-icon step-icon-2"></div>
              <p>Принимаем груз</p>
            </div>
            <div className="scheme-step">
              <div className="scheme-icon step-icon-3"></div>
              <p>Оформляем документы</p>
            </div>
            <div className="scheme-step">
              <div className="scheme-icon step-icon-4"></div>
              <p>Выполняем перевозку</p>
            </div>
            <div className="scheme-step">
              <div className="scheme-icon step-icon-5"></div>
              <p>Получаем оплату и выдаём груз</p>
            </div>
          </div>
        </div>
      </section>
      <section className="contacts-section">
        <div className="container contacts-container">
          <div className="contacts-info">
            <div className="contact-item address">
              <span>Калужская область, Боровский район, п. Ворсино</span>
            </div>
            <div className="contact-item email">
              <span>amlogistic40@mail.ru</span>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Refrigerated;
